import { render } from "./MetodePembuatanRadio.vue?vue&type=template&id=37865d98&scoped=true"
import script from "./MetodePembuatanRadio.vue?vue&type=script&lang=js"
export * from "./MetodePembuatanRadio.vue?vue&type=script&lang=js"

import "./MetodePembuatanRadio.vue?vue&type=style&index=0&id=37865d98&lang=scss&scoped=true"

import exportComponent from "/Users/mymac/Documents/Digitala/Perki/newest-perki/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37865d98"]])

export default __exports__